import { Observable, throwError } from "rxjs";
import { HttpClient, HttpErrorResponse, HttpEvent, HttpParams, HttpRequest, HttpResponse } from "@angular/common/http";
import { CrudOperations } from "./crud-operations.interface";
import { catchError, map } from "rxjs/operators";
import { Billings } from "../models/billings";
import { Orders } from "../models/orders";

interface AvailabilityResponse {
  unavailable_dates: { start: string; end: string }[];
  available_periods: { start: string; end: string }[];
}

export abstract class CrudService<T, ID> implements CrudOperations<T, ID> {
  currentUser: any;
  submitted = false;
  returnUrl: string;
  error: {};
  loginError: string;
  username: string;
  user_id: string;
  size: number;

  password: string;
  first_name: string;
  last_name: string;
  pages: any[];

  constructor(protected _http: HttpClient, protected _base: string) {
    this.currentUser = JSON.parse(localStorage.getItem("currentUser") || "[]");
  }

  getParams(params: HttpParams, pars: any): HttpParams {
    Object.keys(pars).forEach((key) => {
      const value = pars[key];
      if (value !== undefined && value !== null && value !== "") {
        params = params.append(key, value);
      }
    });

    return params;
  }

  public find(id: ID, pars: any): Observable<T[]> {
    let params = new HttpParams();
    params = this.getParams(params, pars);
    return this._http
      .get<HttpResponse<T[]>>(this._base + "/find/" + id, {
        observe: "response",
        params,
      })
      .pipe(
        map((res) => {
          this.size =
            res.headers.get("x-total-count") != null
              ? +res.headers.get("x-total-count")
              : 0;
          const ts: any = res.body;
          return ts;
        }),
        catchError(this.handleError)
      );
  }

  public search(pars: any): Observable<T[]> {
    let params = new HttpParams();
    params = this.getParams(params, pars);
    return this._http
      .get<HttpResponse<T[]>>(this._base + "/search/", {
        observe: "response",
        params,
      })
      .pipe(
        map((res) => {
          this.size =
            res.headers.get("x-total-count") != null
              ? +res.headers.get("x-total-count")
              : 0;
          const ts: any = res.body;
          return ts;
        }),
        catchError(this.handleError)
      );
  }

  getAllList() {
    return this._http
      .get<T>(this._base + "/")
      .pipe(catchError(this.handleError));
  }

  public getAllListNew(pars: any): Observable<T[]> {
    let params = new HttpParams();
    const userId = this.currentUser.user_id;
    params = this.getParams(params, pars);
    return this._http
      .get<HttpResponse<T[]>>(this._base + "/list_user/" + userId, {
        observe: "response",
        params,
      })
      .pipe(
        map((res) => {
          this.size =
            res.headers.get("x-total-count") != null
              ? +res.headers.get("x-total-count")
              : 0;
          const ts: any = res.body;
          return ts;
        }),
        catchError(this.handleError)
      );
  }

  public list(pars: any): Observable<T[]> {
    let params = new HttpParams();
    const userId = this.currentUser.user_id;
    params = this.getParams(params, pars);
    return this._http
      .get<HttpResponse<T[]>>(this._base + "/", {
        observe: "response",
        params,
      })
      .pipe(
        map((res) => {
          this.size =
            res.headers.get("x-total-count") != null
              ? +res.headers.get("x-total-count")
              : 0;
          const ts: any = res.body;
          return ts;
        }),
        catchError(this.handleError)
      );
  }

  check_availability(params: any): Observable<AvailabilityResponse> {
    return this._http.get<AvailabilityResponse>(
      `${this._base}/check_availability`,
      { params }
    );
  }

  public listCalendar(pars: any): Observable<T[]> {
    let params = new HttpParams();
    params = this.getParams(params, pars);
    return this._http
      .get<HttpResponse<T[]>>(this._base + "/calendar/", {
        observe: "response",
        params,
      })
      .pipe(
        map((res) => {
          this.size =
            res.headers.get("x-total-count") != null
              ? +res.headers.get("x-total-count")
              : 0;
          const ts: any = res.body;
          return ts;
        }),
        catchError(this.handleError)
      );
  }

  public getAllListNewMap(pars: any): Observable<T[]> {
    let params = new HttpParams();
    const userId = this.currentUser.user_id;
    params = this.getParams(params, pars);
    return this._http
      .get<HttpResponse<T[]>>(this._base + "/list_user/map/" + userId, {
        observe: "response",
        params,
      })
      .pipe(
        map((res) => {
          this.size =
            res.headers.get("x-total-count") != null
              ? +res.headers.get("x-total-count")
              : 0;
          const ts: any = res.body;
          return ts;
        }),
        catchError(this.handleError)
      );
  }

  public getAllListDocuments(pars: any, id: ID): Observable<T[]> {
    let params = new HttpParams();
    const userId = this.currentUser.user_id;
    params = this.getParams(params, pars);
    return this._http
      .get<HttpResponse<T[]>>(this._base + "/list_user/" + id + "/" + userId, {
        observe: "response",
        params,
      })
      .pipe(
        map((res) => {
          this.size =
            res.headers.get("x-total-count") != null
              ? +res.headers.get("x-total-count")
              : 0;
          const ts: any = res.body;
          return ts;
        }),
        catchError(this.handleError)
      );
  }

  public find_timesheets_employee(pars: any, id: ID): Observable<T[]> {
    let params = new HttpParams();
    const userId = this.currentUser.user_id;
    params = this.getParams(params, pars);
    return this._http
      .get<HttpResponse<T[]>>(
        this._base + "/timesheets_by_employee/" + id + "/" + userId,
        {
          observe: "response",
          params,
        }
      )
      .pipe(
        map((res) => {
          this.size =
            res.headers.get("x-total-count") != null
              ? +res.headers.get("x-total-count")
              : 0;
          const ts: any = res.body;
          return ts;
        }),
        catchError(this.handleError)
      );
  }

  public find_documents(pars: any, id: ID): Observable<T[]> {
    let params = new HttpParams();
    const userId = this.currentUser.user_id;
    params = this.getParams(params, pars);
    return this._http
      .get<HttpResponse<T[]>>(
        this._base + "/timesheets_by_employee/" + id + "/" + userId,
        {
          observe: "response",
          params,
        }
      )
      .pipe(
        map((res) => {
          this.size =
            res.headers.get("x-total-count") != null
              ? +res.headers.get("x-total-count")
              : 0;
          const ts: any = res.body;
          return ts;
        }),
        catchError(this.handleError)
      );
  }

  public getAllTimesheetsbyProject(pars: any, id: ID): Observable<T[]> {
    let params = new HttpParams();
    const userId = this.currentUser.user_id;
    params = this.getParams(params, pars);
    return this._http
      .get<HttpResponse<T[]>>(
        this._base + "/timesheets_by_project/" + id + "/" + userId,
        {
          observe: "response",
          params,
        }
      )
      .pipe(
        map((res) => {
          this.size =
            res.headers.get("x-total-count") != null
              ? +res.headers.get("x-total-count")
              : 0;
          const ts: any = res.body;
          return ts;
        }),
        catchError(this.handleError)
      );
  }

  getAllListbyUser() {
    const userId = this.currentUser.user_id;
    return this._http
      .get<T>(this._base + "/user/" + userId)
      .pipe(catchError(this.handleError));
  }

  getAllTasksListbyUser(project_id: string) {
    const userId = this.currentUser.user_id;
    return this._http
      .get<T>(this._base + "/user_project/" + project_id + "/" + userId)
      .pipe(catchError(this.handleError));
  }

  count() {
    const userId = this.currentUser.user_id;
    return this._http
      .get<T>(this._base + "/count/" + userId)
      .pipe(catchError(this.handleError));
  }

  countCharts() {
    const userId = this.currentUser.user_id;
    return this._http
      .get<T>(this._base + "/user/" + userId)
      .pipe(catchError(this.handleError));
  }

  countChartsNone() {
    const userId = this.currentUser.user_id;
    return this._http
      .get<T>(this._base + "/user_none/" + userId)
      .pipe(catchError(this.handleError));
  }

  getToday(userId: string) {
    return this._http
      .get<T>(this._base + "/today/" + userId)
      .pipe(catchError(this.handleError));
  }

  getActive(userId: string) {
    return this._http
      .get<T>(this._base + "/active/" + userId)
      .pipe(catchError(this.handleError));
  }

  getRoomsVariations(id: string) {
    const userId = this.currentUser.user_id;
    return this._http.get<Billings>(
      this._base + "/variations_by_product/" + id + "/" + userId
    );
  }

  search_client(name: string) {
    return this._http
      .get<T>(this._base + "/search/?name=" + name)
      .pipe(catchError(this.handleError));
  }

  find_billing_client(id: string) {
    return this._http.get<Billings>(this._base + "/billings_by_client/" + id);
  }

  find_tickets_support_id(id: string) {
    const userId = this.currentUser.user_id;
    return this._http.get<Billings>(
      this._base + "/tickets_support_id/" + id + "/" + userId
    );
  }

  find_billings_by_bookings(id: string) {
    return this._http.get<Billings>(
      this._base + "/billings_by_bookings/" + id
    );
  }

  find_billings_by_booking_id(id: string) {
    return this._http.get<Billings>(
      this._base + "/billings_by_booking_id/" + id
    );
  }

  find_billings_by_order_id(id: string) {
    return this._http.get<Billings>(
      this._base + "/get_billings_by_order_id/" + id
    );
  }

  find_orders_by_quotes_id(id: string) {
    return this._http.get<Orders>(this._base + "/get_order_by_quotes_id/" + id);
  }

  find_tasks_employee(id: ID) {
    const userId = this.currentUser.user_id;
    return this._http
      .get<T>(this._base + "/tasks_by_employee/" + id + "/" + userId)
      .pipe(catchError(this.handleError));
  }

  timesheets_by_employee_calendar(id: ID) {
    const userId = this.currentUser.user_id;
    return this._http
      .get<T>(
        this._base + "/timesheets_by_employee_calendar/" + id + "/" + userId
      )
      .pipe(catchError(this.handleError));
  }

  count_total_permissions_timesheets_employee(id: ID) {
    const userId = this.currentUser.user_id;
    return this._http
      .get<T>(
        this._base +
          "/count_total_permissions_timesheets_employee/" +
          id +
          "/" +
          userId
      )
      .pipe(catchError(this.handleError));
  }

  count_total_vacations_timesheets_employee(id: ID) {
    const userId = this.currentUser.user_id;
    return this._http
      .get<T>(
        this._base +
          "/count_total_vacations_timesheets_employee/" +
          id +
          "/" +
          userId
      )
      .pipe(catchError(this.handleError));
  }

  count_total_timesheets_employee(id: ID) {
    const userId = this.currentUser.user_id;
    return this._http
      .get<T>(
        this._base + "/count_total_timesheets_employee/" + id + "/" + userId
      )
      .pipe(catchError(this.handleError));
  }

  timesheet_by_project_employee(id: ID) {
    const userId = this.currentUser.user_id;
    return this._http
      .get<T>(
        this._base + "/timesheet_by_project_employee/" + id + "/" + userId
      )
      .pipe(catchError(this.handleError));
  }

  skills(id: ID) {
    const userId = this.currentUser.user_id;
    return this._http
      .get<T>(this._base + "/skills/" + id + "/" + userId)
      .pipe(catchError(this.handleError));
  }

  countTotal(id: ID) {
    const userId = this.currentUser.user_id;
    return this._http
      .get<T>(this._base + "/count_total/" + userId)
      .pipe(catchError(this.handleError));
  }

  get_projects_timesheets_chart(id: ID) {
    const userId = this.currentUser.user_id;
    return this._http
      .get<T>(this._base + "/get_projects_timesheets_chart/" + id)
      .pipe(catchError(this.handleError));
  }

  send(emailData: any) {
    return this._http.post(this._base + "/send/", emailData, {
      headers: { "Content-Type": "application/json" },
    });
  }

  countTotalNotPaid(id: ID) {
    const userId = this.currentUser.user_id;
    return this._http
      .get<T>(this._base + "/count_total_no_paid/" + userId)
      .pipe(catchError(this.handleError));
  }

  getId(id: ID) {
    return this._http
      .get<T>(this._base + "/id/" + id)
      .pipe(catchError(this.handleError));
  }

  delete_image(id: string) {
    const userId = this.currentUser.user_id;
    return this._http
      .delete(this._base + "/delete_image/" + id + "/" + userId)
      .pipe(catchError(this.handleError));
  }

  getImages(id: ID): Observable<any> {
    const userId = this.currentUser.user_id;
    return this._http.get<T>(this._base + "/getimages/" + id + "/" + userId);
  }

  upload(file: File, id): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();
    const userId = this.currentUser.user_id;

    formData.append("product_id", id);
    formData.append("image", file);
    formData.append("image_order", "0");
    formData.append("description", "");

    const req = new HttpRequest("POST", `${this._base}/create/`, formData, {
      reportProgress: true,
      responseType: "json",
    });

    return this._http.request(req);
  }

  get_comuni() {
    return this._http
      .get<T>(this._base + "/list_public/")
      .pipe(catchError(this.handleError));
  }

  create(blog) {
    const userId = this.currentUser.user_id;
    return this._http
      .post<any>(this._base + "/create/", blog)
      .pipe(catchError(this.handleError));
  }

  update(blog, id: string) {
    return this._http
      .post<any>(this._base + "/update/" + id, blog)
      .pipe(catchError(this.handleError));
  }

  update_skills(blog, id: string) {
    const userId = this.currentUser.user_id;
    return this._http
      .post<any>(this._base + "/update_skills/" + id + "/" + userId, blog)
      .pipe(catchError(this.handleError));
  }

  update_priority(blog, id: string) {
    const userId = this.currentUser.user_id;
    return this._http
      .post<any>(this._base + "/update_priority/" + id + "/" + userId, blog)
      .pipe(catchError(this.handleError));
  }

  update_quantity(blog, id: string) {
    const userId = this.currentUser.user_id;
    return this._http
      .post<any>(this._base + "/update_quantity/" + id + "/" + userId, blog)
      .pipe(catchError(this.handleError));
  }

  update_priority_employee(blog, id: string) {
    const userId = this.currentUser.user_id;
    return this._http
      .post<any>(
        this._base + "/update_priority_employee/" + id + "/" + userId,
        blog
      )
      .pipe(catchError(this.handleError));
  }

  billingStatus(blog, id: string) {
    const userId = this.currentUser.user_id;
    return this._http
      .post<any>(this._base + "/billing_status/" + id + "/" + userId, blog)
      .pipe(catchError(this.handleError));
  }

  delete(id: string) {
    return this._http
      .delete(this._base + "/delete/" + id + "/")
      .pipe(catchError(this.handleError));
  }

  save(t: T): Observable<T> {
    return this._http.post<T>(this._base, t);
  }

  update_new(id: ID, t: T): Observable<T> {
    return this._http.put<T>(this._base + "/" + id, t, {});
  }

  findOne_new(id: ID): Observable<T> {
    return this._http.get<T>(this._base + "/" + id);
  }

  findAll_new(): Observable<T[]> {
    return this._http.get<T[]>(this._base);
  }

  delete_new(id: ID): Observable<T> {
    return this._http.delete<T>(this._base + "/" + id);
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {

      console.error("An error occurred:", error.error.message);
    } else {

    }

    const apiMessage = error?.error?.message;
    return throwError(
      typeof apiMessage === "string" && apiMessage
        ? apiMessage
        : "Something bad happened. Please try again later."
    );
  }
}
